import axios from 'axios';
import { createQuery } from 'react-query-kit';

import { restUrl } from '@/services/utils';

import type { EditorTask, TaskAttachment, TaskComment } from './taskView';

const useTask = createQuery<EditorTask | null, { taskId: number | string }>({
    queryKey: ['task'],
    fetcher: async ({ taskId }): Promise<EditorTask | null> => {
        const response = await axios.get(restUrl(`taskLists/tasks/${taskId}`));
        const data = response.data;
        if (!data || typeof data !== 'object' || Array.isArray(data)) {
            return null;
        }
        return data as EditorTask;
    },
});

const useTaskComments = createQuery<TaskComment[], { taskId: number | string }>({
    queryKey: ['taskComments'],
    fetcher: async ({ taskId }): Promise<TaskComment[]> => {
        const response = await axios.get(restUrl(`taskLists/tasks/${taskId}/comments`));
        return Array.isArray(response.data) ? response.data : [];
    },
});

const saveTask = async (task: EditorTask): Promise<EditorTask> => {
    const response = await axios.post<EditorTask>(restUrl(`taskLists/tasks/${task.id}`), task);
    return response.data;
};

const saveTaskComment = async (
    taskId: number | string,
    comment: { text: string; author?: string; assets?: TaskAttachment[] },
): Promise<void> => {
    await axios.post(restUrl(`taskLists/tasks/${taskId}/comments`), {
        ...comment,
        taskId,
    });
};

export { saveTask, saveTaskComment, useTask, useTaskComments };
